


















import { Component, Vue, Prop } from "vue-property-decorator";
import { AnalysisStatus as Status } from "@/api/analyses_status/types";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import AnalysisStatusIcons from "@/utils/iconAnalysisStatus";

@Component({
  name: "AnalysisStatus",
  components: {
    AgroIcons,
  },
})
export default class AnalysisStatus extends Vue {
  @Prop({ type: Array, required: true })
  private analysisStatusList!: Status[];

  get sortedYears() {
    return this.analysisStatusList.sort((first, last) =>
      first.year > last.year ? -1 : 1
    );
  }

  private cropTypeIconName(status: string, step: string) {
    return AnalysisStatusIcons.fromText(status, step);
  }

  private getTitle(status: Status) {
    if (status.finishedWithSuccess) {
      return this.$t('analysis.finished-with-success');
    }
    return `${ this.$t('analysis.step.' + status.step) + ' - ' + this.$t('analysis.status.' + status.status) }`
  }
}
